import { DatadogRUM } from '@user-portal/datadog-rum';
import { createFirehoseEventWriter, ExperimentationClientConfig } from '@user-portal/experimentation';

const eventWriter = createFirehoseEventWriter({
    identityPoolId: import.meta.env.EXPERIMENTATION_COGNITO_IDENTITY_POOL_ID,
    streamName: import.meta.env.EXPERIMENTATION_AWS_DELIVERY_STREAM_NAME,
    eventSourceName: 'walk-fit-portal',
});

export const experimentationConfig: ExperimentationClientConfig = {
    apiKey: import.meta.env.EXPERIMENTATION_API_KEY,
    stage: import.meta.env.ENV,
    projectName: 'WFw',
    projectNamespace: 'portal-wf',
    eventWriter,
    metricWriter: DatadogRUM.getExperimentationMetricWriter(),
};
